import { Link, useLoaderData } from "react-router-dom";
import MapComponent from "../components/MapComponent";
import { getAllStages, loadFestivalData, getStageColor } from "../services/dataService";
import { BasePage } from "./BasePage";

export const loadMapPageData = async () => {
  await loadFestivalData();
  return { stages: getAllStages() };
};

export default function MapPage() {
  const { stages } = useLoaderData<typeof loadMapPageData>();

  return (
    <BasePage>
      <div className="space-y-6 pb-6">
        {/* Map Header */}
        <div className="bg-[#222222]/65 border border-white/5 rounded-2xl p-5 backdrop-blur-md">
          <h1 className="font-['Unbounded'] text-xl font-bold text-white uppercase tracking-wider mb-4">
            Térkép
          </h1>
          <div className="bg-black/40 border border-white/5 rounded-xl p-2 overflow-hidden flex items-center justify-center">
            <MapComponent />
          </div>
        </div>

        {/* Stages list under map */}
        <div className="bg-[#222222]/65 border border-white/5 p-5 rounded-2xl backdrop-blur-md">
          <h2 className="font-['Unbounded'] text-base font-bold text-accent mb-4 uppercase tracking-wider pl-0.5">
            Színpadok
          </h2>
          <div className="space-y-3">
            {stages
              .filter((e) => !e.hidden)
              .map((stage) => {
                const stageColor = getStageColor(stage.id);
                return (
                  <div
                    key={stage.id}
                    className="relative flex items-stretch border border-white/5 bg-white/[0.02] rounded-xl overflow-hidden hover:bg-white/[0.04] transition-all"
                  >
                    <div className="w-1 flex-shrink-0" style={{ backgroundColor: stageColor }} />
                    <Link
                      to={`/stage/${stage.id}`}
                      className="block flex-1 p-3.5 group hover:no-underline"
                    >
                      <div className="flex flex-col items-start gap-1">
                        <div className="flex items-center">
                          <span
                            className="w-2 h-2 rounded-full mr-2"
                            style={{ backgroundColor: stageColor }}
                          />
                          <h3 className="font-['Unbounded'] font-bold text-sm text-white group-hover:text-main transition-colors uppercase tracking-wide">
                            {stage.name}
                          </h3>
                        </div>
                        <p className="text-xs text-muted leading-relaxed mt-1">
                          {stage.description}
                        </p>
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </BasePage>
  );
}
